/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Detail_Applications_Hidden_TitleInputs */

const en_job_detail_applications_hidden_title = /** @type {(inputs: Job_Detail_Applications_Hidden_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications become visible once time slots are added`)
};

const de_job_detail_applications_hidden_title = /** @type {(inputs: Job_Detail_Applications_Hidden_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen werden sichtbar, sobald Termine angelegt sind`)
};

/**
* | output |
* | --- |
* | "Applications become visible once time slots are added" |
*
* @param {Job_Detail_Applications_Hidden_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_detail_applications_hidden_title = /** @type {((inputs?: Job_Detail_Applications_Hidden_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Detail_Applications_Hidden_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_detail_applications_hidden_title(inputs)
	return en_job_detail_applications_hidden_title(inputs)
});